var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.pageLoaded)?_c('article-with-contents',{ref:"refarticle",staticClass:"section",attrs:{"contents":_vm.pageData.fields.contents}},[_c('v-row',[_c('v-col',[_c('h2',[_vm._v(_vm._s(_vm.pageData.fields.title))])])],1),_vm._v(" "),_c('v-row',[_c('v-col',[_c('article',{domProps:{"innerHTML":_vm._s(_vm.pageData.fields.article)}})])],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }